import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const courierServiceFee = async (data: object) => {
  return await POST({
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      resourceKey: 'payment.service.CourierServiceFeeDeductFacade.queryDeductList'
    },
    url: Api.courierServiceFee,
    data,
    showError: false
  })
}
